<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormMaterial" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objArticulosAlmacen.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdArticuloCategoria">Categoría</label>
							<select v-model="objArticulosAlmacen.IdArticuloCategoria" class="form-control-search form-select" id="IdArticuloCategoria">
								<option value="0">Seleccione una Categoría</option>
								<option v-for="(item, index) in Categorias" :key="index" :value="item.IdArticuloCategoria">{{item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdArticuloCategoria" :Mensaje="'*'+errorvalidacion.IdArticuloCategoria[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoMaterial">Tipo de Material</label>
							<select v-model="objArticulosAlmacen.TipoMaterial" class="form-control-search form-select" id="TipoMaterial">
								<option value="">Seleccione una opción</option>
								<option value="Material">Material</option>
								<option value="Herramienta">Herramienta</option>
								<option value="Insumo">Insumo</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoMaterial" :Mensaje="'*'+errorvalidacion.TipoMaterial[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Stock">Pzs en Stock</label>
							<input @input="$onlyNums($event,objArticulosAlmacen,'Stock')" type="text" v-model="objArticulosAlmacen.Stock" class="form-control" id="Stock" placeholder="Ingresar Existencias" />
							<CValidation v-if="this.errorvalidacion.Stock" :Mensaje="'*'+errorvalidacion.Stock[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="MinimoStock">Stock Mínimo</label>
							<input @input="$onlyNums($event,objArticulosAlmacen,'MinimoStock')" type="text" v-model="objArticulosAlmacen.MinimoStock" class="form-control" id="MinimoStock" placeholder="Ingresar MinimoStock" />
							<CValidation v-if="this.errorvalidacion.MinimoStock" :Mensaje="'*'+errorvalidacion.MinimoStock[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="MaximoStock">Stock Maximo</label>
							<input @input="$onlyNums($event,objArticulosAlmacen,'MaximoStock')" type="text" v-model="objArticulosAlmacen.MaximoStock" class="form-control" id="MaximoStock" placeholder="Ingresar MaximoStock" />
							<CValidation v-if="this.errorvalidacion.MaximoStock" :Mensaje="'*'+errorvalidacion.MaximoStock[0]"/>
						</div>
					</div>
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormMaterial',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objArticulosAlmacen: {
				IdArticuloAlmacen: 0,
				Nombre: '',
				IdArticuloCategoria: 0,
				Stock: 0,
				StockReal:0,
				MinimoStock: 0,
				MaximoStock: 0,
				TipoMaterial: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Categorias:[]
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objArticulosAlmacen.IdArticuloAlmacen == 0) {
				await this.$http.post(
					'articulosAlmacen',this.objArticulosAlmacen
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'articulosAlmacen/'+this.objArticulosAlmacen.IdArticuloAlmacen,
					this.objArticulosAlmacen
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "articulosAlmacen/"+this.objArticulosAlmacen.IdArticuloAlmacen
            ).then((res) => {
                this.objArticulosAlmacen = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objArticulosAlmacen.Fecha.replace(/-/g,'\/');
                this.objArticulosAlmacen.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objArticulosAlmacen = {
				IdArticuloAlmacen: 0,
				Nombre: '',
				IdArticuloCategoria: 0,
				Stock: 0,
				MinimoStock:0,
				MaximoStock:0,
				IdEmpresa: 0,
				IdSucursal: 0,
				TipoMaterial: '',
				
            }
            this.errorvalidacion = [];
        },
		ListaCategorias()
		{
			this.$http.get('articulosCategoria', {
                params: {
                    simple: 1,
                    TipoCategoria: 'Producto',
                }
            }).then((res) =>
            {
                this.Categorias = res.data.data;
            });
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            // $('.vue-treeselect__menu-container').css('z-index','9999999');
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
			this.ListaCategorias();

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objArticulosAlmacen.IdArticuloAlmacen = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
